import React, { useState, useEffect } from 'react';
import axios from 'axios';

import { getBackendUrl } from '../utils/getBackendUrl';
const BACKEND_URL = getBackendUrl();
const API = `${BACKEND_URL}/api`;

const toUrl = (p) => (p && p.startsWith('http') ? p : `${BACKEND_URL}${p}`);

export const WelcomeSplash = ({ user, onDone }) => {
  const [imgUrl, setImgUrl] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        if (user.role === 'client') {
          const [projRes, heroRes] = await Promise.all([
            axios.get(`${API}/projects`),
            axios.get(`${API}/project-hero-thumbnails`),
          ]);
          const proj = (projRes.data || []).find((p) => heroRes.data[p.id]);
          if (proj && !cancelled) setImgUrl(toUrl(heroRes.data[proj.id]));
        } else if (user.profile_picture) {
          setImgUrl(toUrl(user.profile_picture));
        }
      } catch (e) { /* fall back to text-only splash */ }
      if (!cancelled) setReady(true);
    };
    load();
    const cap = setTimeout(() => { if (!cancelled) setReady(true); }, 2500);
    return () => { cancelled = true; clearTimeout(cap); };
  }, [user]);

  useEffect(() => {
    if (!ready) return;
    const t = setTimeout(onDone, 3000);
    return () => clearTimeout(t);
  }, [ready, onDone]);

  if (!ready) return null;

  const firstName = (user.name || '').split(' ')[0];

  if (user.role === 'client' && imgUrl) {
    return (
      <div className="fixed inset-0 z-[200]" style={{ backgroundColor: '#0f172a' }} data-testid="welcome-splash-client">
        <img src={imgUrl} alt="Your project" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0" style={{ background: 'linear-gradient(to top, rgba(2,6,23,0.85) 0%, rgba(2,6,23,0.15) 45%, rgba(2,6,23,0.4) 100%)' }} />
        <div className="absolute bottom-0 inset-x-0 p-8 text-center animate-fade-in-up">
          <p className="text-sm uppercase tracking-widest mb-1" style={{ color: '#fbbf24' }}>Dawal Construction</p>
          <h1 className="text-3xl font-bold" style={{ color: '#ffffff' }}>Welcome back, {firstName}</h1>
          <p className="text-sm mt-2" style={{ color: '#cbd5e1' }}>Here&apos;s a look at your project…</p>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 z-[200] flex flex-col items-center justify-center p-8" style={{ backgroundColor: '#0f172a' }} data-testid="welcome-splash-employee">
      {imgUrl ? (
        <img
          src={imgUrl}
          alt={user.name}
          className="w-40 h-40 rounded-full object-cover shadow-2xl animate-fade-in-up"
          style={{ border: '4px solid #f59e0b' }}
        />
      ) : (
        <div
          className="w-40 h-40 rounded-full flex items-center justify-center text-5xl font-bold shadow-2xl animate-fade-in-up"
          style={{ backgroundColor: '#f59e0b', color: '#0f172a', border: '4px solid #fbbf24' }}
        >
          {(user.name || '?').split(' ').map((w) => w[0]).join('').slice(0, 2).toUpperCase()}
        </div>
      )}
      <h1 className="text-3xl font-bold mt-6 text-center animate-fade-in-up" style={{ color: '#ffffff' }}>Welcome back, {firstName}</h1>
      <p className="text-sm mt-2 uppercase tracking-widest" style={{ color: '#fbbf24' }}>Dawal Construction</p>
    </div>
  );
};

export default WelcomeSplash;
